import * as Yup from 'yup';

import { FormikHelpers, FormikValues } from 'formik';
import { NumberField, SearchSelectField } from '../../../components';
import { TipoFiltroBuscaEleitoresDocenteEnum, TipoGrupoEleitoresEnum } from '../../../enums';

import { ApiHelper } from '../../../helpers';
import { Axios } from 'axios';
import DocentesLecionandoDepartamentoCursoFormType from '../../../types/busca-eleitores/docentes/DocentesLecionandoDepartamentoCursoFormType';
import { FunctionComponent } from 'react';
import { StatusCodes } from 'http-status-codes';
import { useCursos } from '../../../hooks';
import { useTranslation } from 'react-i18next';

export const initialValuesDocentesExternosLecionandoCursoForm = (
  t: Function,
  tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum,
) => ({
  ano: '',
  periodo: '',
  selectedForm: t('label.docentes_externos_lecionando_no_curso'),
  ...{ curso: '' },
});

export const validationSchemaDocentesExternosLecionandoCursoForm = (
  t: Function,
  tipoFiltro: TipoFiltroBuscaEleitoresDocenteEnum,
) =>
  Yup.object().shape({
    ano: Yup.number().required(t('validacao.campo_obrigatorio')),
    ...(tipoFiltro === TipoFiltroBuscaEleitoresDocenteEnum.LECIONANDO_CURSO && {
      curso: Yup.string().required(t('validacao.campo_obrigatorio')),
    }),
    periodo: Yup.number().required(t('validacao.campo_obrigatorio')),
  });

export const onSubmitDocentesExternosLecionandoCursoForm =
  (t: Function, axios: Axios, setResultado: Function, setLoading: Function, setErrorStatus: Function, errorHandler: Function) =>
  (values: FormikValues, formikHelpers: FormikHelpers<FormikValues>) => {
    setLoading(true);
    axios
      .get(ApiHelper.getUrl.apiSCE.buscaEleitores(TipoGrupoEleitoresEnum.DOCENTE_EXTERNO), {
        params: {
          consulta: 'LECIONANDO_CURSO',
          ...{ curso: values.curso },
          ano: values.ano,
          periodo: values.periodo,
        },
      })
      .then((response) => {
        setResultado(response.data);
        setLoading(false);
      })
      .catch((error) => {
        if (error.response.status === StatusCodes.NOT_FOUND) {
          setErrorStatus(error.response.status);
        } else {
          errorHandler(error, t('erro.recuperar_eleitores'));
        }
      })
      .finally(() => {
        formikHelpers.setSubmitting(false);
      });
  };
const DocentesExternosLecionandoCursoForm: FunctionComponent<DocentesLecionandoDepartamentoCursoFormType> = ({
  formikProps,
  tipoFiltro,
}) => {
  const { t } = useTranslation();
  const cursos = useCursos(null, null);

  return (
    <div>
      <SearchSelectField
        label={t('label.curso')}
        name={'curso'}
        formikProps={formikProps}
        options={cursos}
        required
        key={`select-curso`}
      />
      <div className="row pt-3">
        <div className="col">
          <NumberField formikProps={formikProps} label={t('label.ano')} name="ano" required maxLength={4} />
        </div>
        <div className="col">
          <NumberField formikProps={formikProps} label={t('label.periodo')} name="periodo" required maxLength={1} />
        </div>
      </div>
    </div>
  );
};

export default DocentesExternosLecionandoCursoForm;
